/* Package JSON Import will be here */
import React from "react";
import { useSelector } from "react-redux";
import { getTranslate } from "react-localize-redux";
import classNames from "classnames";
/* Package JSON Import will be here */

const AppVersion = (props) => {
    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale)
    }));

    return (
        <h4
            className={classNames('appVersion', 'mb-3 m-auto', {
                'color-white': props.isFromDrawer
            })}
        >
            {translate("common.version")}{" "}
            {`${process.env.REACT_APP_MAJOR_VERSION}.${process.env.REACT_APP_MINOR_VERSION}.${process.env.REACT_APP_ITERATION_VERSION}.${process.env.REACT_APP_HEAD_COUNT}`}
        </h4>
    );
};

export default AppVersion;